/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Check = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 12L9.5 17L19.5 7"
          stroke="#002967"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.00004L5.66667 12.6667L15 3.33337"
        stroke="#002967"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Check;
